import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import InvoiceDetail from "@components/modules/invoices/Detail";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationOutgoingInvoice } from "@src/components/widgets/AppSubNav/navigation-invoices/outgoing-invoices";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Outgoing invoice detail`}
    navigation={<NavigationOutgoingInvoice invoiceId={id} />}
  >
    <InvoiceDetail.Outgoing id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/outgoing-invoices/detail")({
  component: RouteComponent,
});
